const projectRef = process.env.REACT_APP_SUPABASE_PROJECT_REF || 'fqygopfflgckjkilqsqp';
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || `https://${projectRef}.supabase.co`;

export const apiConfig = {
  baseUrl: process.env.REACT_APP_API_URL || `${supabaseUrl}/functions/v1`,
} as const;

export const supabaseConfig = {
  projectRef,
  url: supabaseUrl,
  anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || '',
} as const;

export const appConfig = {
  name: 'Pellvr',
  version: '0.1.0',
  environment: process.env.NODE_ENV || 'development',
} as const;

export const storageKeys = {
  accessToken: 'beaver_token',
  currentStoreId: 'beaver_store_id',
  currentOrgId: 'beaver_org_id',
  pendingOnboarding: 'beaver_pending_onboarding',
} as const;

